import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch} from 'react-redux';
import './EmpresaCard.css';
import { getCompanyById } from './api';
import {loginFailure } from '../../actions/index';
import { API_URL } from '../../config';

const EmpresaCard = () => {
  const dispatch = useDispatch();
  const User = useSelector((state) => state.auth.user);
  const machines = useSelector((state) => state.machine.machines);
  const [count, setCount] = useState(0);
  const [info, setInfo] = useState({});
  const [daysLeft, setDaysLeft] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  

  useEffect(() => {
    setCount(machines.length);
  }, [machines]);

  useEffect(() => {
    const fetchEmpresaInfo = async () => {
      try {
        const response = await getCompanyById(User.Id_Empresa);
        setInfo(response);
        setImageUrl(`${API_URL}${response.Foto_Emp}`);
        const expiryDate = new Date(response.Expiry_Date_Emp);
        const today = new Date();
        const differenceInTime = expiryDate.getTime() - today.getTime();
        const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));

        setDaysLeft(differenceInDays);
        if (differenceInDays <=0 && count === 0) {
          alert('¡Contactanos para activar tu cuenta!');
          dispatch(loginFailure('¡Contactanos para activar tu cuenta!'));
        }else if(differenceInDays < 0){
          alert('¡La suscripción de la empresa ha vencido! recuerda contactar a soporte técnico para renovarla.');
          dispatch(loginFailure('¡La suscripción de la empresa ha vencido! recuerda contactar a soporte técnico para renovarla.'));
        }else if (differenceInDays <= 3) {
          alert('¡La suscripción de la empresa está a punto de vencer! recuerda contactar a soporte técnico para renovarla.');
        }else {
          setDaysLeft(null);
        }
      } catch (error) {
        alert(error.message);
      }
    };

    if (User) {
      fetchEmpresaInfo();
    }
  }, [User]);

  return (
    <div className="empresa-card">
      <div className="empresa-card-logo">
        <img src={imageUrl} alt="Logo de la empresa" />
      </div>
      <div className="empresa-card-info">
        <p><strong>Nit:</strong> {info.Nit_Emp}</p>
        <p><strong>Empresa:</strong> {info.Name_Emp}</p>
        <p><strong>Dirección:</strong> {info.Adress_Emp}</p>
        <p><strong>Usuario activo:</strong> {User.Name_User}</p>
        <p><strong>Cargo:</strong> {User.Cargo_User}</p>
        <p><strong>Teléfono:</strong> {info.Tel_Emp}</p>
      </div>
      <div className="empresa-card-info">
        <p><strong>Vencimiento de Subcripción:</strong> {info.Expiry_Date_Emp}</p>
        {daysLeft !== null && (
          <p><strong>Días restantes hasta el vencimiento:</strong> {daysLeft} días</p>
        )}
        <p><strong>E-mail:</strong> {info.Email_Emp}</p>
        <p><strong>Equipos ingresados:</strong> {count}</p>
        <a href={info.Website_Emp}><strong>{info.Website_Emp}</strong></a>
        <p></p>
      </div>
    </div>
  );
};

export default EmpresaCard;
